<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <CRow>
          <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT')">
            <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                        ref="districtCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="5" md="5" lg="5" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE') || $hasAuthor('ROLE_MANAGEMENT') || $hasAuthor('ROLE_DISTRICT')">
            <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2">
            <BaseSelect :options="connectStatusSelect.options" :data="connectStatusSelect.data"
                        ref="connectStatusSelect"></BaseSelect>
          </CCol>
          <CCol xs="12" sm="6" md="6" lg="6" xl="2" class="d-flex align-items-end justify-content-end ml-xl-auto">
            <CButton
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataDevice()"
            >
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </CCol>
          <!--          <CCol xs="12" sm="6" md="6" lg="6" xl="2">-->
          <!--            <BaseSelect :options="activeStatusSelect.options" :data="activeStatusSelect.data"-->
          <!--                        ref="activeStatusSelect"></BaseSelect>-->
          <!--          </CCol>-->
          <!--          <CCol xs="12" sm="6" md="6" lg="6" xl="2">-->
          <!--            <BaseInput-->
          <!--              :options="codeInput.options"-->
          <!--              :data="codeInput.data"-->
          <!--              :listener="codeInput.listener"/>-->
          <!--          </CCol>-->
          <!--          <CCol xs="12" sm="6" md="6" lg="6" xl="2">-->
          <!--            <BaseInput-->
          <!--              :options="descriptionInput.options"-->
          <!--              :data="descriptionInput.data"/>-->
          <!--          </CCol>-->
        </CRow>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <GoogleMap :items="itemsMap"></GoogleMap>
      </CCardBody>
    </CCard>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import {DatePicker} from "v-calendar";
import BaseModal from "@/views/base/BaseModal";
import GoogleMap from "@/views/devices/GoogleMap";

export default {
  name: "DeviceMap",
  components: {
    GoogleMap,
    BaseModal,
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseSwitch,
    ModalConfirm,
    BaseTextArea,
    BaseFormLoading,
    RangeSlider,
    DatePicker,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: {value: false},

      codeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "code",
          model: "",
          lastValue: ''
        },
        listener: {
          keyup: function (event) {
            if (event.key === "Enter") {
              that.loadDataDevice();
            }
          },
        }
      },
      descriptionInput: {
        options: {
          placeholder: "Mô tả",
          label: 'Mô tả'
        },
        data: {
          name: "description",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },

      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE') || this.$hasAuthor('ROLE_MANAGEMENT')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          // disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },

      connectStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái kết nối',
        },
        data: {
          name: "connectStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Kết nối"},
            {key: "0", value: "Mất kết nối"},
          ],
          model: "-1",
        }
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: 'Trạng thái hoạt động',
        },
        data: {
          name: "activeStatus",
          items: [
            {key: "-1", value: "Tất cả"},
            {key: "1", value: "Hoạt động"},
            {key: "0", value: "Không hoạt động"},
          ],
          model: "-1",
        }
      },

      itemsMap: []

    };
  },
  methods: {
    loadDataDevice: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/listForMap",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            response.data.data.map(each => {
              if (each.latitude && each.longitude) {
                each.position = {lat: Number(each.latitude), lng: Number(each.longitude)}
              }
            })
            that.itemsMap = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
    if (!this.$hasAuthor('ROLE_ADMIN')) {
      this.showErrorMsg({ message: 'Bạn không có quyền truy cập trang bản đồ thiết bị.' });
      this.$router.replace('/dashboard.html').catch(() => {});
      return;
    }
    this.loadDataDevice();
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        // this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        // this.wardCodeInput.options.disabled = false;
      } else {
        // this.wardCodeInput.data.items = [];
        // this.wardCodeInput.options.disabled = true;
      }
      this.$refs.wardCodeInput.loadData();
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      this.loadDataDevice();
    },
    'connectStatusSelect.data.model': function () {
      this.loadDataDevice();
    },
    'codeInput.data.model': function () {

    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

.slider {
  width: 200px;
  max-width: 200px;
  //padding: 0 !important;
}

.range-slider-rail, .range-slider-fill {
  height: 6px !important;
}

.range-slider-fill {
  background-color: #0b98ff;
}

.range-slider-knob {
  width: 15px !important;
  height: 15px !important;
}

.range-slider {
  padding: unset !important;
}

.dropdown-volume {
  padding: unset;
  border-radius: 50px;
}

.dropdown-volume a:hover {
  background: none !important;
}

.custom-toggle-volume {
  min-width: 70px;
  display: inline-flex !important;
  justify-content: center;
}

.custom-toggle-volume i {
    margin-top:0px !important;
}

.volume .dropdown {
  display: inline-flex !important;
}

.action-custom {
  height: 200px;
  overflow: auto;
}

.group-btn-action {
  height: 35px;
}

.group-btn-action:hover {
  background: unset !important;
}
</style>
